import { ArrowRight, CreditCard, Zap, Shield, HelpCircle } from "lucide-react";
import { motion } from "framer-motion";
import { Footer } from "../../Footer";
import img2 from "../../../assets/vector2.png";
import img1 from "../../../assets/Vector1.png";
import img3 from "../../../assets/plans-img.svg";
import img5 from "../../../assets/plan-fast.png";
import img4 from "../../../assets/plan-secure.png";
import img6 from "../../../assets/plan-bill.png";
import { Nav } from "../../Nav";
import { Plans } from "./Plans";
import { TestimonialSwiper } from "../../TestimonialSwiper";
import { PricingFAQ } from "../../PricingFAQ";

export const Pricing = () => {
  return (
    <>
      <div className="w-full overflow-hidden">
        <Nav />

        <Plans />

        {/* Enterprise Contact */}
        {/* <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="rounded-2xl overflow-hidden bg-[#F8FAFC] border border-gray-100"
            >
              <div className="px-6 py-12 sm:px-12">
                <div className="lg:flex lg:items-center lg:justify-between">
                  <div className="lg:w-2/3">
                    <h3 className="text-[36px] font-bold text-gray-900">
                      Need a custom solution?
                    </h3>
                    <p className="mt-4 text-xl text-[#697586]">
                      Join thousands using custom Gomens solutions to power
                      their businesses
                    </p>
                  </div>
                  <div className="mt-8 lg:mt-0 lg:w-1/3 lg:flex lg:justify-end">
                    <a
                      href="/contact"
                      className="inline-flex items-center justify-center px-6 py-3 text-base font-medium rounded-lg border-[1px] border-gray-300 bg-white text-black hover:shadow-lg transition-all duration-300"
                    >
                      Start Creating for free                      
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </section> */}

        {/* Features Included */}

        <section className="w-full py-5 md:py-10 bg-white flex items-center justify-center flex-col">
          <div className="text-area text-center md:w-[33%]">
            <p className="text-[18px] text-[#5937F8]">No Hidden Fees</p>
            <h3 className="text-[48px] font-[play]">All Plans Include</h3>
            <p className="text-[18px] text-[#697586]">
              Essential features are available across all our plans to ensure you
              get the best experience
            </p>
          </div>

          <div className="left-right w-full flex-col md:flex-row px-5 flex items-center justify-center gap-8 md:gap-16 mt-16">
            <div className="left md:w-[40%]">
              <div className="flex items-center justify-center gap-5 mb-8 md:mb-5">
                <img src={img4} alt="" />
                <div>
                  <h2 className="text-[24px]">Secure Processing</h2>
                  <p className="text-[16px] text-[#697586]">
                    Your images are processed securely with end-to-end
                    encryption and never shared with third parties.
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-center gap-5 mb-8 md:mb-5">
                <img src={img5} alt="" />
                <div>
                  <h2 className="text-[24px]">Fast Results</h2>
                  <p className="text-[16px] text-[#697586]">
                    Our optimized AI algorithms deliver fast results so you can keep your workflow moving.
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-center gap-5 ">
                <img src={img6} alt="" />
                <div>
                  <h2 className="text-[24px]">Simple Billing</h2>
                  <p className="text-[16px] text-[#697586]">
                    Transparent pricing with no hidden fees. Cancel anytime with our no-questions-asked policy.
                  </p>
                </div>
              </div>
            </div>
            <div className="right md:w-[40%]">
              <img src={img3} alt="" />
            </div>
          </div>
        </section>
        {/* Testimonial - Single highlighted one */}
        <TestimonialSwiper />
           {/* CTA Section */}
                <section className="py-12 sm:py-16 bg-white px-4 sm:px-6 md:px-8 lg:px-16">
                  <div className="max-w-7xl xl:max-w-8xl mx-auto">
                    <motion.div
                      initial={{ opacity: 0, scale: 0.95 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.5 }}
                      viewport={{ once: true }}
                      className="relative rounded-2xl sm:rounded-3xl overflow-hidden bg-black min-h-[300px] sm:min-h-[350px] md:min-h-[400px] lg:h-[400px]"
                    >
                      <div className="relative px-4 sm:px-6 md:px-8 lg:px-12 xl:px-32 py-8 sm:py-12 md:py-16 h-full flex items-center">
                        {/* Background Images */}
                        <img
                          className="hidden sm:block object-cover absolute top-2 left-2 w-16 sm:w-20 md:w-24 lg:w-auto h-auto opacity-50"
                          src={img1}
                          alt=""
                        />
                        <img
                          className="hidden sm:block object-cover absolute bottom-4 right-4 sm:right-6 w-16 sm:w-20 md:w-24 lg:w-auto h-auto opacity-50"
                          src={img2}
                          alt=""
                        />
        
                        <div className="text-center flex items-center justify-center flex-col w-full z-10 relative">
                          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[56px] font-bold text-white leading-tight sm:leading-tight md:leading-tight lg:leading-[4vw] font-[Playfair-Display] mb-4 sm:mb-6">
                            Transform your garment photos into stunning, on-model imagery in seconds
                          </h2>
                          <p className="text-sm sm:text-base md:text-lg lg:text-[20px] text-gray-300 w-full sm:w-[90%] md:w-[80%] lg:w-[65%] xl:w-[55%] mb-6 sm:mb-8">
                            Join thousands using Gomens to save time and money on traditional photoshoots.
                          </p>
                          <div>
                            <a
                              href="/signup"
                              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 text-sm sm:text-base font-medium rounded-lg shadow-lg bg-white text-black hover:bg-gray-100 transition-all duration-300"
                            >
                              Generate Your First Model (Free)
                            </a>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </div>
                </section>

        {/* FAQ Section */}
        <section className="py-16 bg-white overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center flex-col">
            <p className="text-purple-500 text-[18px]">Still Curious?</p>
            <h2 className="text-[48px] font-[Playfair-Display] font-bold text-gray-900 text-center">
              Frequently Asked Questions
            </h2>
            <p className="text-[18px] text-gray-600 mb-[60px]">
              Quick answers about how our tools work, what files we support, and
              how to get started.
            </p>
            <PricingFAQ />
          </div>
        </section>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};
